import React, { useState, useCallback, useMemo, useContext, useRef, useEffect } from 'react'
import { formatOccupantsShort } from 'lib/offer/occupancyUtils'
import { StandaloneFlightMenu } from 'components/Flights/FlightsSearch/SearchWidget/FlightSearchWidget'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import FlightSearchMenuDesktop from '../FlightSearchMenu/FlightSearchMenuDesktop'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'
import FlightSearchTravellerSelectContent from '../FlightTravellerSelect/FlightSearchTravellerSelectContent'
import FlightSearchTravellerSelectField from '../FlightTravellerSelect/FlightSearchTravellerSelectField'

interface Props {
  className?: string;
  anchorRef?: React.RefObject<HTMLElement>;
  disabled?: boolean;
}

function FlightSearchTravellerSelect({ className, anchorRef, disabled }: Props) {
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)

  const { occupants, activeMenu } = state
  const [preOpenOccupants, setPreOpenOccuapnts] = useState<App.Occupants | undefined>()
  const travellerLabel = useMemo(() => formatOccupantsShort(occupants), [occupants])

  const setActiveMenu = useCallback((activeMenu?: StandaloneFlightMenu) => {
    dispatch({ type: FlightSearchWidgetActions.SET_ACTIVE_MENU, activeMenu })
  }, [dispatch])

  const onApply = useCallback(() => {
    setPreOpenOccuapnts(undefined)
    setActiveMenu()
  }, [setActiveMenu])

  const onCancel = useCallback(() => {
    // revert back to the occupants from before we opened on a 'cancel' click
    dispatch({ type: FlightSearchWidgetActions.SET_OCCUPANTS, occupants: preOpenOccupants })
    setPreOpenOccuapnts(preOpenOccupants)
    setActiveMenu()
  }, [dispatch, preOpenOccupants, setActiveMenu])

  const handleOpen = useCallback(() => {
    setActiveMenu(StandaloneFlightMenu.occupants)
  }, [setActiveMenu])

  useEffect(() => {
    if (activeMenu === StandaloneFlightMenu.occupants) {
      setPreOpenOccuapnts(occupants)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenu])

  const triggerRef = useRef<HTMLButtonElement>(null)

  return (
    <div className={className}>
      <FlightSearchTravellerSelectField
        onClick={handleOpen}
        ref={triggerRef}
        disabled={!!disabled}
      />
      <FlightSearchMenuDesktop
        open={activeMenu === StandaloneFlightMenu.occupants}
        onCancel={onCancel}
        onApply={onApply}
        triggerRef={triggerRef}
        travellerLabel={travellerLabel}
        anchorRef={anchorRef}
      >
        <FlightSearchTravellerSelectContent />
      </FlightSearchMenuDesktop>
    </div>
  )
}

export default FlightSearchTravellerSelect
